export default "__VITE_ASSET__ETV40CXe__"